import { PostResponse } from "../api-client/usePost";
import { usePostJson } from "../api-client/usePostJson";
import { useCartDropdownState } from "../blocks/Cart/CartPreview/CartPreview";
import { PricingOption } from "../blocks/PriceSelect/getFlatPricingOptions";
import { AnyPartType } from "../constants/partTypes";
import { useCartNext } from "../stores/hooks/useCartNext";
import { OrderDetails } from "../stores/slices/cartSlice";
import { StockItem } from "./useSearchTiresByVehicle";

type AddItemToCartInput = {
  dealerId: number;
  itemId: string;
  itemType: AnyPartType;
  orderNumber: string;
  partStock: StockItem[];
  pricingOption: Pick<PricingOption, "context" | "quantity">;
  vehicleId: null | number;
};

type AddItemToCart = (payload: AddItemToCartInput[]) => Promise<void>;

type AddItemToCartJsonPayload = {
  cartId: string;
  dealerId: number;
  itemId: string;
  itemQty: number;
  itemType: AnyPartType;
  optionId: string;
  orderNumber: string;
  partStock: StockItem[];
  pricingContextId: string;
  vehicleId: null | number;
};

export const useAddItemToCart = (): Omit<PostResponse<OrderDetails>, "send"> & {
  send: AddItemToCart;
} => {
  const [, { show: showCartPreview }] = useCartDropdownState();
  const { sendJson: addItemToCart, ...post } = usePostJson<
    OrderDetails,
    AddItemToCartJsonPayload
  >("/retailSiteWebService/shopping/cart/addItemToCart.php");
  const cartNext = useCartNext();
  const send: AddItemToCart = async (payload) => {
    for await (const item of payload) {
      const {
        dealerId,
        itemId,
        itemType,
        orderNumber,
        partStock,
        pricingOption: { context, quantity },
        vehicleId,
      } = item;
      const response = await addItemToCart({
        cartId: orderNumber,
        dealerId,
        itemId,
        itemQty: Number(quantity),
        itemType,
        optionId: "0",
        orderNumber,
        partStock,
        pricingContextId: context.pricingContextId,
        vehicleId,
      });
      cartNext(response.payload);
    }
    showCartPreview();
  };
  return { ...post, send };
};
